<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed, defineComponent, onMounted } from 'vue'

import { useAuthStore } from '@/stores/authStore.ts';
import ModalRenderer from '@/components/ui/ModalRenderer.vue';
import SnackbarComponent from '@/components/ui/SnackbarComponent.vue';

defineComponent([ModalRenderer, SnackbarComponent])

const authStore = useAuthStore()
const route = useRoute()

const layout = computed(() => route.meta.layout || 'div')

onMounted(() => {
  if (authStore.auth.authenticated) {
    authStore.me()
  }
})
</script>

<template>
  <component :is="layout">
    <RouterView/>
    <ModalRenderer/>
  </component>
  <SnackbarComponent/>
</template>
